<template>
  <el-dialog
    title="Add new question category"
    width="600px"
    :before-close="handleCancel"
    :visible.sync="isVisible"
  >
    <el-form
      label-position="right"
      label-width="150px"
      ref="categoryForm"
      :model="categoryForm"
      :rules="rules"
    >
      <el-form-item label="Title" prop="title">
        <el-input v-model="categoryForm.title"></el-input>
      </el-form-item>
      <el-form-item label="Description" prop="description">
        <el-input type="textarea" v-model="categoryForm.description"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">Cancel</el-button>
      <el-button type="primary" @click="handleCreate">Create</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as surveyBuilderTypes from '@/store/modules/surveybuilder/mutation-types';

const initialFormData = () => ({
  title: '',
  description: '',
});

export default {
  name: 'QuestionCategoryCreateDialog',
  data: () => ({
    categoryForm: initialFormData(),
    rules: {
      title: [
        { required: true, message: 'Please enter title of the category', trigger: 'blur' },
        { min: 3, message: 'Length should be a minimum of 3 characters', trigger: 'blur' },
      ],
    },
  }),
  computed: {
    isVisible: {
      get() {
        return this.$store.state.surveybuilder.questionCategoryDialogVisible;
      },
      set(value) {
        this.$store.commit(
          `surveybuilder/${surveyBuilderTypes.SET_QUESTION_CATEGORY_DIALOG_VISIBILITY}`,
          value,
        );
      },
    },
  },
  methods: {
    resetForm() {
      this.categoryForm = initialFormData();
      this.$refs.categoryForm.resetFields();
    },

    handleCancel() {
      this.isVisible = false;
      this.resetForm();
    },

    handleCreate() {
      this.$refs.categoryForm.validate(valid => {
        if (valid) {
          this.$store
            .dispatch('surveybuilder/questionCategoryDialogCreate', {
              title: this.categoryForm.title,
              description: this.categoryForm.description,
            })
            .then(() => {
              this.$store.dispatch('surveybuilder/getQuestionCategories');
              this.resetForm();
              this.isVisible = false;
            });
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// QuestionCategoryCreateDialog.vue?304c65d6